import { Type, Transform } from "class-transformer";
import { observable } from "mobx";

export default class GeneralSettingsInfo {
  @observable
  @Transform(value => (value ? new Date(value) : undefined), { toClassOnly: true })
  last_enum_update?: Date;
}
